import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  IApiServiceConfig,
  API_SERVICE_CONFIG,
} from '../base/configuration/api-service-config';
import { WorkOrderBlockingMotive } from './blocking-motives';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiWorkOrderBlockingMotivesAdapterService {
  constructor(
    private http: HttpClient,
    @Inject(API_SERVICE_CONFIG) private config: IApiServiceConfig,
  ) {}

  private baseUrl = this.config.url + 'work-orders/blocking-motives';

  getAll(): Observable<WorkOrderBlockingMotive[]> {
    return this.http.get<WorkOrderBlockingMotive[]>(this.baseUrl);
  }

  create(name: string): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(this.baseUrl, { name });
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
